var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21276 0L13.6761 0C16.5508 0 18.8889 2.3387 18.8889 5.21285L18.8889 13.676C18.8889 16.5501 16.5508 18.8889 13.6761 18.8889L5.21276 18.8889C2.3381 18.8889 0 16.5506 0 13.676L0 5.21285C0 2.3387 2.3381 0 5.21276 0ZM13.6761 17.213C15.6266 17.213 17.213 15.6266 17.213 13.676L17.213 5.21285C17.213 3.2627 15.6261 1.6759 13.6761 1.6759L5.21276 1.6759C3.2621 1.6759 1.6759 3.2627 1.6759 5.21285L1.6759 13.676C1.6759 15.6266 3.2621 17.213 5.21276 17.213L13.6761 17.213Z",
    id: "Fill-7",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00004C0 2.24309 2.24287 0 4.99987 0C7.75705 0 10 2.24309 10 5.00004C10 7.75708 7.75705 10 4.99987 10C2.24287 10 0 7.75708 0 5.00004ZM1.72168 5.00004C1.72168 6.80785 3.1922 8.27835 4.99987 8.27835C6.80771 8.27835 8.27832 6.80785 8.27832 5.00004C8.27832 3.19241 6.80771 1.72165 4.99987 1.72165C3.1922 1.72165 1.72168 3.19241 1.72168 5.00004Z",
    transform: "translate(4.444336 4.444824)",
    id: "Fill-10",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11115 0C0.819097 0 0.532549 0.11831 0.326243 0.32508C0.11893 0.531386 0 0.818012 0 1.11107C0 1.40313 0.11893 1.68983 0.326243 1.89706C0.532549 2.10329 0.819097 2.22222 1.11115 2.22222C1.40421 2.22222 1.68991 2.10329 1.89714 1.89706C2.10391 1.68983 2.22222 1.40313 2.22222 1.11107C2.22222 0.818012 2.10391 0.531386 1.89714 0.32508C1.69099 0.11831 1.40421 0 1.11115 0",
    transform: "translate(13.33301 3.333496)",
    id: "Fill-12",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstagram);
export default __webpack_public_path__ + "static/media/ico-instagram.58c31145d56fe0565fc5d24b33ad112b.svg";
export { ForwardRef as ReactComponent };